import { render, staticRenderFns } from "./Colture.vue?vue&type=template&id=fbe251a8&scoped=true&"
import script from "./Colture.vue?vue&type=script&lang=js&"
export * from "./Colture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe251a8",
  null
  
)

export default component.exports